module.exports = "<span [ngStyle]=\"{backgroundColor: value}\"></span>\r\n"


//////////////////
// WEBPACK FOOTER
// ./libs/atenea-cms/src/color-input/color-input.component.html
// module id = ./libs/atenea-cms/src/color-input/color-input.component.html
// module chunks = main